import EstimatedDateSetup from '@/components/EstimatedDateSetup';
import { IStateCheckoutRule } from '@/pages/Checkout/components/CreateUpdate';
import MessageText from '@/pages/Checkout/components/MessageText';
import SelectShippingMethod from '@/pages/Checkout/components/SelectShippingMethod';
import onboardingSlice, { onboardingSelector } from '@/redux/slice/onboarding.slice';
import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface IProps {}

const EditCheckoutRule = (props: IProps) => {
  const dispatch = useDispatch();
  const onboarding = useSelector(onboardingSelector);

  const handleSetError = useCallback(
    (msg: string) => {
      dispatch(onboardingSlice.actions.handleSetError({ status: !!msg, msg }));
    },
    [dispatch],
  );

  const handleUpdateState = (key: keyof IStateCheckoutRule) => (value: IStateCheckoutRule[keyof IStateCheckoutRule]) => {
    dispatch(
      onboardingSlice.actions.handleChangeCheckoutRule({
        [key]: value,
      }),
    );
  };

  useEffect(() => {
    if (onboarding?.checkoutRule?.shippingMethods?.length === 0 || !onboarding?.checkoutRule?.messageText) {
      handleSetError('This field is required');
    } else handleSetError('');
  }, [handleSetError, onboarding?.checkoutRule?.messageText, onboarding?.checkoutRule?.shippingMethods?.length]);

  return (
    <div className="d-flex flex-column gap-12">
      <SelectShippingMethod
        isRequired
        selectedOptions={onboarding?.checkoutRule?.shippingMethods}
        setSelectedOptions={handleUpdateState('shippingMethods')}
        defaultOptions={[]}
        customSetError={handleSetError}
      />

      <MessageText
        isRequired
        inputValue={onboarding?.checkoutRule?.messageText}
        setInputValue={handleUpdateState('messageText')}
      />

      <EstimatedDateSetup
        required
        orderToShipDays={onboarding?.checkoutRule?.minPreparationDays?.toString() || '0'}
        onChangeOrderToShipDays={(newValue) => {
          handleUpdateState('minPreparationDays')(newValue);
        }}
        prepDays={onboarding?.checkoutRule?.maxPreparationDays?.toString() || '6'}
        onChangePrepDays={(newValue) => {
          handleUpdateState('maxPreparationDays')(newValue);
        }}
        shipToReceiveDays={onboarding?.checkoutRule?.minDeliveryDays?.toString() || '0'}
        onChangeShipToReceiveDays={(newValue) => {
          handleUpdateState('minDeliveryDays')(newValue);
        }}
        estDays={onboarding?.checkoutRule?.maxDeliveryDays?.toString() || '8'}
        onChangeEstDays={(newValue) => {
          handleUpdateState('maxDeliveryDays')(newValue);
        }}
      />
    </div>
  );
};

export default memo(EditCheckoutRule);
